import React from 'react';

import Tag from './Tag';

/**
 * @typedef {{
 *  onDelete : (filterId:string, value:any) => void;
 * } & import('../types').Filter} Props
 *
 * @param {Props} props
 * @returns {React.FC<Props>}
 */
const Filter = ({ id: filterId, name, onDelete, values = [] }) => (
  <div data-cy={`filters-${filterId}`} className="d-inline-flex align-items-center flex-wrap gap-2 mr-0 filter">
    <span className="text-secondary text-sm">{name}:</span>
    {values.map((value) => (
      <Tag key={value.key ?? value.value} filterId={filterId} onDelete={onDelete} {...value} />
    ))}
  </div>
);

export default Filter;
